import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AlleviateNauseaAndVomitingComponent } from '@consultation-upsells/alleviate-nausea-and-vomiting/alleviate-nausea-and-vomiting.component';
import { AlleviateNauseaAndVomitingPeptideComponent } from '@consultation-upsells/alleviate-nausea-and-vomiting/peptide/alleviate-nausea-and-vomiting-peptide.component';
import { AlleviateNauseaAndVomitingTrtComponent } from '@consultation-upsells/alleviate-nausea-and-vomiting/trt/alleviate-nausea-and-vomiting-trt.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { ConsultationStorageService } from '@services/consultation-storage.service';

/**
 * Switcher component that dynamically displays the appropriate Zofran upsell component based on the
 * consultation treatment type.
 */
@Component({
  selector: 'app-alleviate-nausea-and-vomiting-switcher',
  standalone: true,
  imports: [
    CommonModule,
    AlleviateNauseaAndVomitingComponent,
    AlleviateNauseaAndVomitingTrtComponent,
    AlleviateNauseaAndVomitingPeptideComponent,
  ],
  templateUrl: './alleviate-nausea-and-vomiting-switcher.component.html',
})
export class AlleviateNauseaAndVomitingSwitcherComponent {
  public readonly ConsultationTreatmentTypes: typeof ConsultationTreatmentTypes = ConsultationTreatmentTypes;

  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Gets the current treatment type from the consultation storage service.
   */
  public get treatmentType(): ConsultationTreatmentTypes {
    return this.consultationStorageService.treatmentType;
  }
}
